import { Platform } from "react-native";

import { cleanStaffPath, isCentralHostname } from "./hosting-contract";

export { cleanStaffPath, isCentralHostname } from "./hosting-contract";

export function isCentralHost() {
  if (Platform.OS !== "web" || typeof window === "undefined") {
    return false;
  }

  return isCentralHostname(window.location.hostname);
}

export function isPublicWebHost() {
  return Platform.OS === "web" && typeof window !== "undefined" && !isCentralHostname(window.location.hostname);
}

export function staffPath(path: string) {
  return isCentralHost() ? cleanStaffPath(path) : path;
}
